import React from 'react'
import t from 'prop-types'

const IconChevronRight = ({ width, height }) => {
  return (
<svg width={width} height={height} viewBox="0 0 16 37" xmlns="http://www.w3.org/2000/svg" >

    <g  className="fill-white group-hover:fill-blue-100 transition-colors ease-linear duration-200" stroke="none" stroke-width="1"  fill="#ffffff" fill-rule="evenodd">
        <g transform="translate(-1104.000000, -8786.000000)"  fill-rule="nonzero">
            <path d="M1105.11774,8786.7869 C1105.74831,8786.3283 1106.61641,8786.43254 1107.12258,8787.00495 L1107.2131,8787.11774 L1119.85475,8804.5 L1107.2131,8821.88226 C1106.72585,8822.55224 1105.78772,8822.70036 1105.11774,8822.2131 C1104.48717,8821.75451 1104.31887,8820.89653 1104.70748,8820.23861 L1104.7869,8820.11774 L1116.144,8804.5 L1104.7869,8788.88226 C1104.3283,8788.25169 1104.43254,8787.38359 1105.00495,8786.87742 L1105.11774,8786.7869 Z" id="Path-8-Copy"></path>
        </g>
    </g>
</svg>
  )
}

IconChevronRight.propTypes = {
  width: t.oneOf(t.number, t.string),
  height: t.oneOf(t.number, t.string),
}

IconChevronRight.defaultProps = {
  width: 16,
  height: 37,
}

export default IconChevronRight